import React from "react";
import {
    Container,
    Row,
    Col,
    Navbar,
    Nav,
    
} from "react-bootstrap";

import userico from "../assets/panelImages/user/user.png"

import 'bootstrap/dist/css/bootstrap.min.css';
import '../App.css';
import './Dashboard.css'
import ExtendedSignUp from "./ExtendedSignUp";
import Sidebar from "./Sidebar/Sidebar";
import HeaderNavbar from "./HeaderNavbar";
import { Outlet } from "react-router-dom";

function Layout() {    return (
        <>
            <Container fluid>
                <Row>
                    <Sidebar />
                    {/* Main Content */}
                    <Col xs={12} md={10} className="bg-light-grey px-5" style={{ paddingLeft: "30px", paddingBottom:"30px" }}>
                    <Row>
                         <Col xs={6} md={6} >
                         
                         </Col>
                         <Col xs={6} md={6} >
                          <HeaderNavbar /></Col>
                    </Row>
                      

                       <Outlet />

                       
                    </Col>
                </Row>
            </Container>

           
            <ExtendedSignUp />
               

        </>
    );
}


export default Layout